import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangleIcon, LoaderIcon, PlayIcon } from 'lucide-react';
import { IMAGES, PRICES } from '../data/funnel';
import { useOrder } from '../contexts/OrderContext';
import { CheckoutSteps } from '../components/CheckoutSteps';
const chapters = [{
  time: '00:00',
  title: 'Postura correcta antes de tocar la columna'
}, {
  time: '12:40',
  title: 'Masaje respiratorio: presión, ritmo y señales de alerta'
}, {
  time: '28:15',
  title: 'Descompresión Spine-Shield en 3 movimientos'
}, {
  time: '44:30',
  title: 'Progresión semanal y errores que causan lesión'
}];
export function Oto1Page() {
  const navigate = useNavigate();
  const {
    addMasterclass
  } = useOrder();
  function accept() {
    addMasterclass();
    navigate('/gracias');
  }
  return <main className="w-full bg-cream pb-24" data-id="element-154" data-mp="1w99l3ttrcywy">
      <div className="bg-alert text-paper" data-id="element-155" data-mp="1w86rvf8yqkdv">
        <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-5 py-2.5 text-center text-xs font-semibold sm:text-sm" data-id="element-156" data-mp="1rbghn8juaj0d">
          <AlertTriangleIcon className="h-4 w-4 shrink-0" data-id="element-157" data-mp="bdoknydkdecr" />
          No cierres ni actualices esta página — tu pedido se está procesando.
        </div>
      </div>

      <header className="border-b border-navy-deep/10 bg-paper" data-id="element-158" data-mp="l3rc3u51ek8z">
        <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-between gap-3 px-5 py-3.5" data-id="element-159" data-mp="l6dme1jbbduw">
          <span className="flex items-center gap-2 text-sm font-medium text-navy/70" data-id="element-160" data-mp="3okq3kpat5axh">
            <LoaderIcon className="h-4 w-4 animate-spin text-gold" data-id="element-161" data-mp="3on2tppqpyrlm" />
            Procesando pago del Protocolo...
          </span>
          <CheckoutSteps current={2} data-id="element-162" data-mp="1fil3nf8ckb2" />
        </div>
      </header>

      <div className="mx-auto max-w-5xl px-5 pt-10" data-id="element-163" data-mp="1id4rcqf613f">
        <h1 className="max-w-3xl font-display text-[1.75rem] font-bold leading-tight text-navy-deep sm:text-[2.4rem]" data-id="element-164" data-mp="6g6dodj3x97e">
          Espera... Tu pedido está siendo procesado. No cierres esta página.
        </h1>

        <div className="mt-9 grid gap-9 lg:grid-cols-[1.15fr_1fr] lg:gap-12" data-id="element-165" data-mp="1hsp8fgsfqq89">
          <div data-id="element-166" data-mp="3dwdhsd573uwb">
            <div className="relative overflow-hidden rounded-xl bg-navy-deep shadow-lift" data-id="element-167" data-mp="3dw3tctzstvsq">
              <img src={IMAGES.masterclass} alt="Demostración del masaje de columna en un Bulldog Francés" className="aspect-video w-full object-cover opacity-90" data-id="element-168" data-mp="39v1o9wj7apiu" />
              <div className="absolute inset-0 grid place-items-center" data-id="element-169" data-mp="3ixb14t1xyuze">
                <span className="grid h-16 w-16 place-items-center rounded-full bg-paper/95 shadow-lift" data-id="element-170" data-mp="2v7p1y5lkkfre">
                  <PlayIcon className="ml-0.5 h-7 w-7 text-navy-deep" data-id="element-171" data-mp="2q9f3nm4jsz1k" />
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between bg-navy-deep/85 px-4 py-2.5 text-xs font-medium text-gold-pale" data-id="element-172" data-mp="34y1iznu6dqss">
                <span data-id="element-173" data-mp="2cfe1sjiauvwz">Masterclass en video · Protocolo Spine-Shield</span>
                <span data-id="element-174" data-mp="27hm93n9tz5rq">60 min</span>
              </div>
            </div>

            <div className="mt-7 space-y-5 text-[1.0625rem] leading-relaxed text-navy/80" data-id="element-175" data-mp="27f8etgmz5xl8">
              <p data-id="element-176" data-mp="mx7f0ss0rgg9">
                Ya tienes el Blueprint, pero{' '}
                <strong className="font-semibold text-navy-deep" data-id="element-177" data-mp="rqsgiustmsk7">
                  ¿quieres ver exactamente cómo se hacen los masajes respiratorios y los ejercicios
                  de columna en video?
                </strong>
              </p>
              <p data-id="element-178" data-mp="hxuwgk86kvjh">
                La mayoría de las personas aprenden 3 veces más rápido viendo que leyendo. He creado
                una Masterclass en Video de 60 minutos donde te muestro la técnica exacta para el
                protocolo Spine-Shield.
              </p>
            </div>

            <ol className="mt-7 divide-y divide-navy-deep/10 overflow-hidden rounded-xl border border-navy-deep/10 bg-paper" data-id="element-179" data-mp="wrg416hucr9o">
              {chapters.map(c => <li key={c.time} className="flex items-baseline gap-4 px-5 py-3.5" data-id="element-180" data-mp="3hdrfc7y59xtc">
                  <span className="w-12 shrink-0 font-mono text-xs text-navy/45" data-id="element-181" data-mp="3mfgqdnldabhf">{c.time}</span>
                  <span className="text-[0.95rem] text-navy-deep/85" data-id="element-182" data-mp="5jpz9ay6qbtg">{c.title}</span>
                </li>)}
            </ol>
          </div>

          <aside className="lg:sticky lg:top-8 lg:self-start" data-id="element-183" data-mp="q4xr8xduzpi">
            <div className="rounded-2xl border border-navy-deep/10 bg-paper p-6 shadow-card sm:p-7" data-id="element-184" data-mp="3rysk9s7d0syn">
              <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-alert" data-id="element-185" data-mp="3ny8qmylzw7h9">
                Oferta única · no se repite
              </p>
              <h2 className="mt-3 font-display text-xl font-bold leading-snug text-navy-deep" data-id="element-186" data-mp="jipfbu7mtie0">
                Masterclass en Video: Spine-Shield paso a paso
              </h2>
              <div className="mt-5 flex items-end gap-3" data-id="element-187" data-mp="fip0i8gmf56f">
                <span className="font-display text-4xl font-bold leading-none text-navy-deep" data-id="element-188" data-mp="agzmcjy3qbe4">
                  ${PRICES.masterclass}
                </span>
                <span className="pb-1 text-sm text-navy/50 line-through" data-id="element-189" data-mp="2v89tsh1k7621">
                  ${PRICES.masterclassValue}
                </span>
              </div>
              <p className="mt-1.5 text-sm font-semibold text-navy-soft" data-id="element-190" data-mp="1arsho4ula28v">
                Ahorras ${PRICES.masterclassValue - PRICES.masterclass} solo en esta página
              </p>

              <button type="button" onClick={accept} className="mt-6 w-full rounded-lg bg-gold px-5 py-4 text-base font-bold leading-snug text-navy-deep transition-colors duration-150 ease-out hover:bg-gold-light" data-id="element-191" data-mp="1jp2xm3icqfk4">
                SÍ, AGREGAR LA MASTERCLASS POR ${PRICES.masterclass} (Ahorra{' '}
                ${PRICES.masterclassValue - PRICES.masterclass})
              </button>

              <p className="mt-4 text-center text-xs text-navy/55" data-id="element-192" data-mp="27fyi0fkha8hc">
                Se cobra a la misma tarjeta. Sin volver a ingresar datos.
              </p>

              <button type="button" onClick={() => navigate('/gracias')} className="mt-5 w-full border-t border-navy-deep/10 pt-5 text-left text-xs leading-relaxed text-navy/50 underline decoration-navy/25 underline-offset-4 transition-colors duration-150 ease-out hover:text-navy/70" data-id="element-193" data-mp="92f0l5kkxmhl">
                No gracias, prefiero intentar aprender los ejercicios por mi cuenta y arriesgarme a
                hacerlos mal.
              </button>
            </div>
          </aside>
        </div>
      </div>
    </main>;
}